(() => {
  const endpoint = (query) => `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection,product,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last`;
  const escapeText = (value) => String(value || '');
  const isUmbrellaRigQuery = (value) => {
    const query = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return /(?:^|[^a-z0-9])(?:umbrella\s+rigs?|a(?:\s+|\s*-\s*)rigs?|alabama\s+rigs?)(?=$|[^a-z0-9])/.test(query);
  };

  const renderUmbrellaAssist = (container, query) => {
    if (!isUmbrellaRigQuery(query)) return;
    const section = document.createElement('section');
    section.className = 'discovery-search-assist';
    const heading = document.createElement('h2');
    heading.className = 'discovery-search-assist__heading';
    heading.textContent = 'Umbrella rigs';
    const description = document.createElement('p');
    description.className = 'discovery-search-assist__description';
    description.textContent = 'Looking for complete A-rigs and umbrella rigs?';
    const link = document.createElement('a');
    link.className = 'discovery-search-assist__link';
    link.href = '/collections/umbrella-rigs';
    link.textContent = 'Shop umbrella rigs';
    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = ' →';
    link.append(arrow);
    section.append(heading, description, link);
    container.append(section);
  };

  const makeLink = (item, className) => {
    const link = document.createElement('a');
    link.href = item.url;
    link.className = className;
    link.textContent = escapeText(item.title);
    return link;
  };

  const makeProductLink = (item) => {
    const link = document.createElement('a');
    link.href = item.url;
    link.className = 'discovery-search-product';
    return link;
  };

  const makeHeading = (label) => {
    const heading = document.createElement('p');
    heading.className = 'search-bar__result-category';
    heading.textContent = label;
    return heading;
  };

  const getResults = async (query) => {
    const response = await fetch(endpoint(query), { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Predictive search returned ${response.status}`);
    return response.json();
  };

  const renderPredictive = (container, results, query) => {
    container.replaceChildren();
    renderUmbrellaAssist(container, query);
    const resources = results.resources && results.resources.results ? results.resources.results : {};
    const collections = (resources.collections || []).slice(0, 3);
    const products = (resources.products || []).slice(0, 6);
    const pages = (resources.pages || []).slice(0, 3);

    if (collections.length) {
      const group = document.createElement('div');
      group.className = 'discovery-search-group';
      group.append(makeHeading('Collections'));
      const links = document.createElement('ul');
      links.className = 'discovery-search-links';
      collections.forEach((item) => { const row = document.createElement('li'); row.append(makeLink(item, 'search-bar__result-link')); links.append(row); });
      group.append(links);
      container.append(group);
    }

    if (products.length) {
      const group = document.createElement('div');
      group.className = 'discovery-search-group';
      group.append(makeHeading('Products'));
      const productsList = document.createElement('div');
      productsList.className = 'discovery-search-products';
      products.forEach((item) => {
        const link = makeProductLink(item);
        const image = item.featured_image && item.featured_image.url;
        if (image) { const img = document.createElement('img'); img.src = image; img.alt = ''; img.loading = 'lazy'; link.append(img); }
        const details = document.createElement('span');
        const title = document.createElement('span'); title.className = 'discovery-search-product__title'; title.textContent = escapeText(item.title); details.append(title);
        const meta = document.createElement('span'); meta.className = 'discovery-search-product__meta'; meta.textContent = item.available ? `$${item.price}` : 'Sold out'; details.append(meta);
        link.append(details); productsList.append(link);
      });
      group.append(productsList);
      container.append(group);
    }

    if (pages.length) {
      const group = document.createElement('div');
      group.className = 'discovery-search-group';
      group.append(makeHeading('Pages'));
      const links = document.createElement('ul'); links.className = 'discovery-search-links';
      pages.forEach((item) => { const row = document.createElement('li'); row.append(makeLink(item, 'search-bar__result-link')); links.append(row); });
      group.append(links); container.append(group);
    }
  };

  const initPredictive = () => {
    document.querySelectorAll('.search-bar__input').forEach((input) => {
      let timer;
      let sequence = 0;
      input.addEventListener('input', (event) => {
        event.stopImmediatePropagation();
        window.clearTimeout(timer);
        const query = input.value.trim();
        const bar = input.closest('.search-bar');
        const resultsContainer = bar && bar.querySelector('.search-bar__results-inner');
        const resultsPanel = bar && bar.querySelector('.search-bar__results');
        if (!bar || !resultsContainer || !resultsPanel) return;
        const request = ++sequence;
        if (!query) { resultsContainer.replaceChildren(); resultsPanel.setAttribute('aria-hidden', 'true'); return; }
        resultsContainer.replaceChildren();
        renderUmbrellaAssist(resultsContainer, query);
        bar.classList.add('is-expanded', 'is-loading');
        resultsPanel.setAttribute('aria-hidden', 'false');
        timer = window.setTimeout(async () => {
          try {
            const data = await getResults(query);
            if (request === sequence) renderPredictive(resultsContainer, data, query);
          } catch (_) {
            if (request === sequence) {
              resultsContainer.replaceChildren();
              renderUmbrellaAssist(resultsContainer, query);
            }
          } finally {
            if (request === sequence) bar.classList.remove('is-loading');
          }
        }, 160);
      }, true);
    });
  };

  const initFullSearch = () => {
    document.querySelectorAll('[data-umbrella-full-assist]').forEach((assist) => {
      assist.hidden = !isUmbrellaRigQuery(assist.dataset.searchQuery);
    });
    document.querySelectorAll('[data-discovery-full-search]').forEach(async (section) => {
      const query = section.dataset.searchQuery;
      const inner = section.querySelector('.discovery-full-search__inner');
      const target = section.querySelector('[data-discovery-collection-results]');
      if (!query || !inner || !target) return;
      try {
        const data = await getResults(query);
        const collections = (((data.resources || {}).results || {}).collections || []).slice(0, 3);
        if (!collections.length) return;
        collections.forEach((item) => target.append(makeLink(item, 'discovery-full-search__link')));
        inner.hidden = false;
      } catch (_) {}
    });
  };

  document.addEventListener('DOMContentLoaded', () => { initPredictive(); initFullSearch(); });
})();
